import { lazy } from 'react';
import { createBrowserRouter, Navigate, useNavigate } from 'react-router-dom';
import { AuthCallback, AuthGuard } from '@os/auth-client/react';
import { AppShell } from '@/layout/AppShell';
import { addonWeb } from '@/addons/catalog';
import { AddonGate } from '@/addons/AddonGate';

// Pages are lazy (§51).
const Today = lazy(() => import('@/pages/today/TodayPage'));
const Plan = lazy(() => import('@/pages/plan/PlanPage'));
const Math = lazy(() => import('@/pages/math/MathPage'));
const Khata = lazy(() => import('@/pages/khata/KhataPage'));
const English = lazy(() => import('@/pages/english/EnglishPage'));
const Library = lazy(() => import('@/pages/library/LibraryPage'));
const Paper = lazy(() => import('@/pages/paper/PaperPage'));
const Share = lazy(() => import('@/pages/share/SharePage'));
const Exam = lazy(() => import('@/pages/exam/ExamPage'));
const Feel = lazy(() => import('@/pages/feel/FeelPage'));
const Review = lazy(() => import('@/pages/review/ReviewPage'));
const Homework = lazy(() => import('@/pages/review/HomeworkPage'));
const Progress = lazy(() => import('@/pages/progress/ProgressPage'));
const Dashboard = lazy(() => import('@/pages/dashboard/DashboardPage'));
const Settings = lazy(() => import('@/pages/settings/SettingsPage'));
const Addons = lazy(() => import('@/pages/settings/AddonsPage'));

function Callback() {
  const nav = useNavigate();
  return <AuthCallback onComplete={(to) => nav(to, { replace: true })} />;
}

const addonRoutes = addonWeb.flatMap((m) => m.routes.map((r) => ({ ...r, element: <AddonGate addonId={m.id}>{r.element}</AddonGate> })));

export const router = createBrowserRouter([
  { path: '/auth/callback', element: <Callback /> },
  {
    path: '/',
    element: <AuthGuard><AppShell /></AuthGuard>,
    children: [
      { index: true, element: <Today /> },
      { path: 'plan', element: <Plan /> },
      { path: 'math', element: <Math /> },
      { path: 'math/:chapterId', element: <Math /> },
      { path: 'khata/s/:submissionId', element: <Khata /> },
      { path: 'khata/p/:problemId', element: <Khata /> },
      { path: 'english', element: <English /> },
      { path: 'library', element: <Library /> },
      { path: 'paper', element: <Paper /> },
      { path: 'paper/:submissionId', element: <Paper /> },
      { path: 'share', element: <Share /> },
      { path: 'exam', element: <Exam /> },
      { path: 'feel', element: <Feel /> },
      { path: 'review', element: <Review /> },
      { path: 'review/:submissionId', element: <Review /> },
      { path: 'homework', element: <Homework /> },
      { path: 'progress', element: <Progress /> },
      { path: 'dashboard', element: <Dashboard /> },
      { path: 'settings/addons', element: <Addons /> },
      { path: 'settings', element: <Settings /> },
      ...addonRoutes,
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
]);
